import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';

function ScorePopup({ points, visible, streakBonus = false, streak = 0 }) {
  return (
    <AnimatePresence>
      {visible && (
        <motion.div
          key={points + '-' + Date.now()}
          initial={{ opacity: 1, y: 0, scale: 0.6 }}
          animate={{ opacity: 0, y: -90, scale: 1.4 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 1.0, ease: [0.16, 1, 0.3, 1] }}
          style={{
            position: 'fixed',
            top: '35%',
            left: '50%',
            transform: 'translateX(-50%)',
            zIndex: 9999,
            pointerEvents: 'none',
            textAlign: 'center',
          }}
        >
          {/* Points */}
          <div
            style={{
              fontFamily: "'Rajdhani', sans-serif",
              fontWeight: 900,
              fontSize: streakBonus ? '3rem' : '2.5rem',
              lineHeight: 1,
              color: streakBonus ? '#f0b429' : '#22c55e',
              textShadow: streakBonus
                ? '0 0 30px rgba(240,180,41,1), 0 0 60px rgba(240,180,41,0.5)'
                : '0 0 25px rgba(34,197,94,1), 0 0 50px rgba(34,197,94,0.5)',
              whiteSpace: 'nowrap',
            }}
          >
            +{points}
          </div>

          {/* Bonus streak */}
          {streakBonus && streak > 1 && (
            <motion.div
              initial={{ opacity: 0, scale: 0 }}
              animate={{ opacity: 1, scale: 1 }}
              transition={{ delay: 0.05 }}
              style={{
                fontFamily: "'Rajdhani', sans-serif",
                fontWeight: 700,
                fontSize: '0.9rem',
                color: '#fbbf24',
                letterSpacing: '0.12em',
                marginTop: 4,
                textShadow: '0 0 10px rgba(251,191,36,0.8)',
              }}
            >
              🔥 SÉRIE x{streak}
            </motion.div>
          )}
        </motion.div>
      )}
    </AnimatePresence>
  );
}

export default ScorePopup;
